import React from "react";

import useTranslations from "../../../hooks/useTranslations";

import { Textarea } from "../../wombat-ui";
import { FormStepProps } from "../../../screens/MadFormScreen";
import { MadFullFragment } from "../../../graphql/fragments";

const MadInformationForm: React.FC<
  Omit<FormStepProps, "onNext" | "unregister" | "setValue" | "control"> & {
    defaultValues?: MadFullFragment;
  }
> = ({ register, defaultValues }) => {
  const t = useTranslations();

  return (
    <div className="w-1/2">
      <Textarea
        id="madDescriptionInputs"
        name="missionDescription"
        ref={register()}
        label={t("mads.madDescriptionLabel") as string}
        defaultValue={defaultValues?.missionDescription ?? ""}
      />
    </div>
  );
};

export default React.memo(MadInformationForm);
